'use strict'

// A map view plots either an address column (coordinates stored beside it)
// or a pair of number columns. The same helpers run in the live app and tests.

const DEFAULT_MAP_STYLE_URL = 'https://tiles.openfreemap.org/styles/liberty'

const MAP_ROW_LIMIT = 1000

function latitudeKey (uniqueTitle) {

  return `${uniqueTitle}_lat`
}

function longitudeKey (uniqueTitle) {

  return `${uniqueTitle}_lng`
}

function finiteNumber (value) {

  if (value === undefined || value === null || value === '') return null

  const number = typeof value === 'number' ? value : Number(value)

  return Number.isFinite(number) ? number : null
}

function coordinatesFromRow (row, view) {

  if (!row || !view) return null

  if (view.addressColumn) {

    const lat = finiteNumber(row[latitudeKey(view.addressColumn)])
    const lng = finiteNumber(row[longitudeKey(view.addressColumn)])

    if (lat == null || lng == null) return null

    return { lat, lng }
  }

  if (view.latitudeColumn && view.longitudeColumn) {

    const lat = finiteNumber(row[view.latitudeColumn])
    const lng = finiteNumber(row[view.longitudeColumn])

    if (lat == null || lng == null) return null

    return { lat, lng }
  }

  return null
}

function stampMapPoint (displayRow, sourceRow, view) {

  if (!displayRow || !view || view.type !== 'maps') return displayRow

  const point = coordinatesFromRow(sourceRow, view)

  if (!point) return displayRow

  displayRow._lat = point.lat
  displayRow._lng = point.lng

  return displayRow
}

module.exports = {
  DEFAULT_MAP_STYLE_URL,
  MAP_ROW_LIMIT,
  latitudeKey,
  longitudeKey,
  finiteNumber,
  coordinatesFromRow,
  stampMapPoint
}
